import { Route } from 'react-router';
import React, { Suspense } from 'react';
import { CircularProgress } from '@mui/material';

function CustomRoute({
  children,
  path,
  location,
  verifyAge = true,
  ...rest
}) {
  return (
    <Suspense fallback={(
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh',
      }}
      >
        <CircularProgress />
      </div>
    )}
    >
      <Route path={transformPath(path, 'pwa')} {...rest} />
    </Suspense>
  );
}
function transformPath(path, pathPrefix) {
  if (!pathPrefix) {
    return path;
  }
  return `/${pathPrefix}${path}`;
}
export default CustomRoute;
